import { TranslationKey } from '../translations/TranslationKey';

export enum TaskState {
  ToDo = 'ToDo',
  InProgress = 'InProgress',
  Done = 'Done',
}

export const TaskStateTranslationKey: { [taskState in TaskState]: TranslationKey } = {
  [TaskState.ToDo]: 'taskState.toDo',
  [TaskState.InProgress]:  'taskState.inProgress',
  [TaskState.Done]:  'taskState.done',
}
